import { Stack, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { StyledGreenSpan } from '../../../common/StyledGreenSpan/StyledGreenSpan';

import loyaltyBg from '@images/loyalty-slide-bg.webp';
import Logo from '@icons/logo.svg?react';

const StyledImg = styled('img')(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  objectFit: 'cover',
  zIndex: -1,
}));

export const LoyaltySlide = () => {
  const { t } = useTranslation();
  return (
    <Stack
      sx={() => ({
        height: '132px',
        width: '100%',
        position: 'relative',
        borderRadius: '10px',
        overflow: 'hidden',
      })}
    >
      <Stack sx={{ padding: '44px 0 20px 0' }}>
        <Typography
          variant="body1"
          color="common.white"
          sx={{ fontSize: '22px', lineHeight: '115%' }}
        >
          <StyledGreenSpan>{t('cabinetPage.slider.slider2_title_part1')}</StyledGreenSpan>
          <br />
          {t('cabinetPage.slider.slider2_title_part2')}
        </Typography>
        <Typography
          variant="body2"
          color="common.white"
          sx={{ fontSize: '14px', lineHeight: '120%' }}
        >
          {t('cabinetPage.slider.slider2_description')}
        </Typography>
      </Stack>
      <Logo
        style={{
          position: 'absolute',
          top: '10px',
          right: '50%',
          transform: 'translateX(50%)',
        }}
      />
      <StyledImg src={loyaltyBg} alt="stationRequestBg" />
    </Stack>
  );
};
